import { createUseStyles } from 'react-jss';

export const addEditAlertStyles = createUseStyles({
  container: {

  },
});
